import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDatepickerInputEvent,
  MatSort,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import * as moment from "moment";
import { ActivatedRoute, Router } from "@angular/router";
import { GameReportByCompetition } from "src/_models";
import { Location } from "@angular/common";

@Component({
  selector: "gm-report-provider-level",
  templateUrl: "./gr-sport-level.component.html",
  styleUrls: ["../game-report.component.scss"],
})
export class GmRepSportsLevelComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  datalistDisplayedColumns: string[] = [
    "CompetitionName",
    "TotalBets",
    "TotalAmount",
    "TotalCommission",
    "TotalCancel",
    "TotalLost",
    "TotalWon",
    "ToTalCashedOut",
    "CashedOutAmount",
    "TotalProfit",
  ];
  providers: any = [];
  datalist = new MatTableDataSource<GameReportByCompetition>();
  filterUsers = [];
  users = [];
  selected: any = { startDate: 0, endDate: 0 };
  providerId = "";
  userID: string = "";
  operatorId = "";
  origin = [];
  prTitle = ""; 
  category = "";
  subProvider = "";
  sportId: string = null;
  sportName = null;
  userName = null;
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  constructor(
    private appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    this.providerId = this.activatedRoute.snapshot.params.providerId;
    this.sportId = this.activatedRoute.snapshot.params.sportId;
    this.activatedRoute.queryParams.subscribe((params) => {
      this.providerId = params.providerId;
      this.sportName = params.sportName;
      this.sportId = params.sportId;
      this.userName = params.userName;
      this.userID = params.userId;
      this.origin = params["origin"];
      this.category = params["category"];
      this.subProvider = params["subProvider"];
      this.operatorId = params.operatorId;
      this.selected = {
        startDate:
          params.startTime !== "0"
            ? new Date(params.startTime * 1000)
            : new Date(),
        endDate:
          params.endTime !== "0" ? new Date(params.endTime * 1000) : new Date(),
      };
      if (this.providerId && this.sportName) {
        this.getReportData();
      }
      let lowerCaseOrigins = this.origin.map(item => item.toLowerCase());
      this.prTitle = lowerCaseOrigins.length > 0 ? lowerCaseOrigins.join(', ') : "";
    });
  }

  ngAfterViewInit() {
    this.datalist.sort = this.sort;
    this.datalist.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'CompetitionName': return item.competitionName;
        case 'TotalAmount': return item.totalAmount;
        case 'TotalBets': return item.totalBets;
        case 'TotalCommission':return item.totalCommission ;
        case 'TotalCancel':return item.totalCancel;
        case 'TotalLost':return item.totalLost;
        case 'TotalWon':return item.totalWon;
        case 'TotalProfit':return item.totalProfit;
        case 'ToTalCashedOut':return item.totalCashOut;
        case 'CashedOutAmount':return item.cashOutAmount;
        default: return item[property];
      }
    };
  }

  goBackToGameLevel = () => {
    this.router.navigate([`reports/game_report/`]);
  };

  goBackToProviderLevel = () => {
    this.router.navigate([`reports/game_report/${this.providerId}`], {
      queryParams: {
        providerId: this.providerId,
        userId: this.userID ? this.userID : "",
        userName: this.userName ? this.userName : "",
        origin: this.origin ? this.origin : [],
        category: this.category ? this.category : "",
        subProvider : this.subProvider ? this.subProvider : "",
        operatorId: this.operatorId,
        startTime:
          this.selected.startDate !== null
            ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
            : 0,
        endTime:
          this.selected.endDate !== null
            ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
            : 0,
      },
    });
  };
  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.startDate !== null) {
      this.getReportData();
    }
  };

  getReportData = () => {
    try {
      let startDate, endDate;
      this.activatedRoute.queryParams.subscribe((params) => {
        (startDate = params.startTime), (endDate = params.endTime);
      });
      let filters = {
        userId: this.userID ? this.userID : null,
        providerId: this.providerId,
        sportId: this.sportId,
        origin: this.origin ? this.origin : [],
        category: this.category ? this.category : "",
        subProvider : this.subProvider ? this.subProvider : "",
        operatorId: this.operatorId,
        startTime:
          startDate === "0"
            ? 0
            : parseInt(
                (new Date(this.selected.startDate).getTime() / 1000).toFixed(0)
              ),
        endTime:
          endDate === "0"
            ? 0
            : parseInt(
                (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
              ),
      };

      this.appService.getGMReportBySportLevel(filters).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.datalist.data = res.competitionGamesReports
        }
      });
    } catch (err) {}
  };

  goToCompitationLevel = (row: GameReportByCompetition) => {
    let startDate, endDate;
    this.activatedRoute.queryParams.subscribe((params) => {
      (startDate = params.startTime), (endDate = params.endTime);
    });

    this.router.navigate(
      [
        `reports/game_report/${this.providerId}/${this.sportId}/${row.competitionId}`,
      ],
      {
        queryParams: {
          operatorId: this.operatorId,
          providerId: this.providerId,
          sportId: this.sportId,
          sportName: this.sportName,
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          competitionName: row.competitionName,
          competitionId: row.competitionId,
          userId: this.userID ? this.userID : "",
          userName: this.userName ? this.userName : "",

          startTime:
            startDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.startDate).getTime() / 1000).toFixed(
                    0
                  )
                ),
          endTime:
            endDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
                ),
        },
      }
    );
  };
}
